/*
 * @Author: your name
 * @Date: 2021-08-05 20:26:52
 * @LastEditTime: 2025-09-19 15:48:36
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\company\index.js
 */
import request from '../request';

const baseUrl = request.getBaseUrl();
const server = {
  // 公司身份资质上传（生产商、代理商）
  companyFileUpload: `${baseUrl}/user-center/oss/fileUploadForCompanyIdentityLicence`,
  // 交易参数-根据公司查询-前端调用
  queryCompanyPayType(param) {
    return request.post('/user-center/companyConfig/queryPaytype', param);
  },
  buyerCompanyPage(param) {
    return request.post('/user-center/paytype/buyerCompanyPage', param);
  },
  deleteBuyerCompany(param) {
    return request.post('/user-center/paytype/deleteBuyerCompany', param);
  },
  companyRelationPage(param) {
    return request.post('/user-center/paytype/companyRelationPage', param);
  },
  insertBuyerCompany(param) {
    return request.post('/user-center/paytype/insertBuyerCompany', param);
  },
  queryByCompanyId(param) {
    return request.post(
      '/transaction-center/invoiceMode/queryByCompanyId',
      param
    );
  },
  saveInvoiceMode(param) {
    return request.post('/transaction-center/invoiceMode/save', param);
  },
  // 企业是否包含采购方向
  hasPurchase(param) {
    return request.post('/user-center/company/hasPurchase', param);
  },
  // 企业下是否有用户
  hasMember(param) {
    return request.post('/user-center//member/hasMember', param);
  },

  // //查询审批流
  // queryWorkflow:function (params) {
  //     return request.post('/transaction-center/workflow/pageWorkflow', params)
  // },
  // 查询审批流
  pageWorkflow(params) {
    return request.post('/transaction-center/workflow/pageWorkflow', params);
  },
  // 删除审批流
  removeWorkflow(params) {
    return request.post('/transaction-center/workflow/remove', params);
  },
  // 查询审批流详情
  getWorkflow(params) {
    return request.post('/transaction-center/workflow/getWorkflow', params);
  },
  // 添加审批流
  addWorkflow(params) {
    return request.post('/transaction-center/workflow/saveWorkflow', params);
  },
  // 审批人员查询
  queryMembers(params) {
    return request.post('/user-center/member/queryPage', params);
  },
  listWorkflow(params) {
    return request.post('/transaction-center/workflow/listWorkflow', params);
  },
  // 审批流开关查询
  queryApprovalProcessSwitch(params) {
    return request.post(
      '/user-center/companyConfig/queryApprovalProcessSwitch',
      params
    );
  },
  // 审批流开关修改
  saveApprovalProcessSwitch(params) {
    return request.post(
      '/user-center/companyConfig/saveApprovalProcessSwitch',
      params
    );
  },
  // 选商定价审批流操作
  saveOrderAskPrice(params) {
    return request.post('/user-center/companyConfig/saveOrderAskPrice', params);
  },
  // 修改审批流
  updateWorkflow(params) {
    return request.post('/transaction-center/workflow/updateWorkflow', params);
  },

  deletePayType(param) {
    return request.post('/user-center/companyConfig/deletePaytype', param);
  },
  insertPayType(param) {
    return request.post('/user-center/companyConfig/insertPaytype', param);
  },

  // 供应商运营后台---售后单审核列表
  queryAftersalesListForAudit(param) {
    return request.post(
      '/user-center/refund/queryAftersalesListForAudit',
      param
    );
  },

  // 产品目录申请
  applyCategory(param) {
    return request.post('/product/categoryApply/applyCategory', param);
  },

  // 供应商产品目录列表查询
  queryCompanyCategoryPage(param) {
    return request.post(
      '/product/categoryApply/queryCompanyCategoryPage',
      param
    );
  },
  queryCompanyEffectiveCategory(param) {
    return request.post(
      '/product/categoryApply/queryCompanyEffectiveCategory',
      param
    );
  },
  queryCompanyEffectiveCategoryPage(param) {
    return request.post(
      '/product/categoryApply/queryCompanyEffectiveCategoryPage',
      param
    );
  },
  // 获取服务管家信息
  queryCompanyButler() {
    return request.fetch('/user-center/companyButler/queryCompanyButler');
  },
  // 判断公司风险评级
  checkCompanyRisk(params) {
    return request.fetch('/user-center/company/checkCompanyRisk', params);
  },
  // 判断公司风险评分
  checkCompanyRiskPoint(params) {
    return request.fetch('/user-center/company/queryCompanyScore', params);
  },
  // 查询公司身份及附件
  queryCompanyIdentityAttach(params) {
    return request.fetch(
      '/user-center/companyConfig/queryCompanyIdentityAttach',
      params
    );
  },
  // 获取供应商资质
  getSupplierLicence(params) {
    return request.fetch('/user-center/oss/getSupplierLicence', params);
  },
  // 删除公司资质
  removeCompanyIdentityLicense(params) {
    return request.fetch(
      '/user-center/oss/removeCompanyIdentityLicense',
      params
    );
  },
  // 查询采购商品范围设置
  queryPurchaseProductRangeSet(params) {
    return request.post(
      '/user-center/companyConfig/queryBuyProductScope',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  // 设置采购商品范围设置
  updatePurchaseProductRangeSet(params) {
    return request.post(
      '/user-center/companyConfig/saveBuyProductScope',
      params
    );
  },
  // 售后类型查询
  queryAfterSalesType(params) {
    return request.post(
      '/user-center/companyConfig/queryAfterSalesType',
      params
    );
  },
  // 售后类型-插入或更新
  saveAfterSalesType(params) {
    return request.post(
      '/user-center/companyConfig/saveAfterSalesType',
      params
    );
  },
  // 收货地址展示
  getShipment(params) {
    return request.post('/transaction-center/shipment/getShipment', params);
  },
  //  产品目录导出,
  exportCategory(params) {
    return request.post('/product/categoryApply/exportCategory', params, {
      responseType: 'blob',
    });
  },
};

export default server;
